import { useLocation } from 'react-router-dom';
import { Card } from '@greenrinse/ui';

export default function PlaceholderPage() {
  const { pathname } = useLocation();
  return (
    <Card tonal>
      <h2 style={{ textTransform: 'capitalize' }}>{pathname.replace('/', '').replace('-', ' ') || 'Page'}</h2>
      <p className="gr-muted">This module is scheduled for a later sprint (see docs/greenrinse-plan.md).</p>
    </Card>
  );
}
